module.exports = "/_next/static/videos/baseball-3-40c3837f8e8d3861379179cab2377556.webm";